
webpack.register(
    'components/svg-image/svg-image',
    function() {
        return require('components/svg-image/svg-image');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/svg-image/svg-image\" />\r\n\r\n<a class=\"c-social-share-icon\r\n    {{#if className}} {{className}}{{/if}}\r\n    {{#if light}} c-social-share-icon--light{{/if}}\" {{#if inWebView}}href=\"{{appShareUrl}}\"{{else}}($click)=\"open(%event, %element)\"{{/if}} type=\"button\">\r\n    <span class=\"s-social-share__text\">Share</span>\r\n    <button aria-label=\"share\" class=\"s-social-share__icon\">\r\n        <svg-image aria-hidden=\"true\" image=\"sprites.svg#{{icon}}\"></svg-image>\r\n    </span>\r\n</a>");